"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useMemo } from "react";
import Head from "next/head";
import UserSetUpProfileCta from "../../user/utils/set-up-profile/UserSetUpProfileCta";
import MessagesDesktop from "../MessagesDesktop";
import MessagesMobile from "../MessagesMobile";
import useDeviceInfo from "../../../hooks/useDeviceInfo";
import ConnectWallet from "../../common/ConnectWallet";
import { useAuthenticatedContent } from "../../../hooks/useAuthenticatedContent";

// Main layout content that uses the Layout context
function MessagesLayoutContent(t0) {
  const $ = _c(13);
  const {
    children
  } = t0;
  const {
    contentState
  } = useAuthenticatedContent();
  const {
    isApp
  } = useDeviceInfo();
  const containerClassName = "tw-relative tw-flex tw-flex-col tw-flex-1 tailwind-scope";
  let t1;
  bb0: switch (contentState) {
    case "needs-profile":
      {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <><h1 className="tw-text-xl tw-font-bold">You need to set up a profile to continue.</h1><UserSetUpProfileCta /></>;
          $[0] = t2;
        } else {
          t2 = $[0];
        }
        t1 = t2;
        break bb0;
      }
    case "not-available":
      {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <h1 className="tw-text-xl tw-font-bold">This content is not available.</h1>;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        t1 = t2;
        break bb0;
      }
    case "loading":
    case "measuring":
      {
        t1 = null;
        break bb0;
      }
    default:
      {
        t1 = null;
      }
  }
  const connectPrompt = t1;
  let t2;
  bb1: {
    if (contentState === "ready") {
      const Component = isApp ? MessagesMobile : MessagesDesktop;
      let t3;
      if ($[2] !== children) {
        t3 = <div className="tw-relative tw-flex tw-flex-col tw-flex-1 tailwind-scope">{children}</div>;
        $[2] = children;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      let t4;
      if ($[4] !== Component || $[5] !== t3) {
        t4 = <div className="tw-flex-1" id="messages-content"><Component>{t3}</Component></div>;
        $[4] = Component;
        $[5] = t3;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      t2 = t4;
      break bb1;
    }
    if (contentState === "not-authenticated") {
      let t3;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <ConnectWallet />;
        $[7] = t3;
      } else {
        t3 = $[7];
      }
      t2 = t3;
      break bb1;
    }
    if (connectPrompt) {
      let t3;
      if ($[8] !== connectPrompt) {
        t3 = <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-px-6"><div className="tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-4">{connectPrompt}</div></div>;
        $[8] = connectPrompt;
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      t2 = t3;
      break bb1;
    }
    t2 = null;
  }
  const content = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Head><style>{"body { overflow: hidden !important; }"}</style></Head>;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== content) {
    t4 = <>{t3}<div className="tailwind-scope tw-flex tw-flex-col tw-bg-black">{content}</div></>;
    $[11] = content;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
export default function MessagesLayout(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <MessagesLayoutContent>{children}</MessagesLayoutContent>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}